import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

const MIN_DURATION = 1;
const MAX_DURATION = 8;

export function insuranceDurationValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value < MIN_DURATION || control.value > MAX_DURATION
      ? { insuranceDuration: true }
      : null;
  };
}
